export default "__VITE_ASSET__18857fdb__"